import { render, staticRenderFns } from "./SummaryItems.vue?vue&type=template&id=512995bb"
import script from "./SummaryItems.vue?vue&type=script&lang=js"
export * from "./SummaryItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports